import {
  Action,
  ActionType,
  GetStudentListResponse,
} from "models/messagemanagement/getStudentList";
import createReducer from "../../createReducer";

export interface GetStudentListReducerType {
  loading: boolean;
  error?: string;
  studentListResponse?: GetStudentListResponse;
}

const defaultState: GetStudentListReducerType = {
  loading: false,
  error: undefined,
  studentListResponse: undefined,
};

export const getStudentListReducer = createReducer<GetStudentListReducerType>(
  defaultState,
  {
    [ActionType.GET_STUDENT_LIST](state: GetStudentListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_STUDENT_LIST_ERROR](
      state: GetStudentListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        studentListResponse: undefined,
      };
    },
    [ActionType.GET_STUDENT_LIST_SUCCESS](
      state: GetStudentListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        studentListResponse: action.payload,
      };
    },

    [ActionType.RESET_STUDENT_LIST](state: GetStudentListReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        studentListResponse: undefined,
      };
    },
  }
);
